import { triggerIconName } from "@/shared/routines.ts";
import type { TriggerConfig } from "@/types/routines.ts";
import { Calendar, Clock, Mail, MessageSquare, Tag } from "lucide-react";

/**
 * The shared icon name resolved to this platform's lucide component.
 *
 * Its own module rather than a helper hanging off the routine form: the omnibox
 * card draws this icon, and it is reached from the shared biscuit chrome that
 * every heavy artifact renders. Importing it from `RoutineFormFields` would pull
 * the whole routine editor — contact pickers, cron builder, label catalog — into
 * that chunk to get a five-case switch.
 */
export function getTriggerIcon(type: TriggerConfig["type"]) {
  switch (triggerIconName(type)) {
    case "mail":
      return Mail;
    case "tag":
      return Tag;
    case "clock":
      return Clock;
    case "message":
      return MessageSquare;
    default:
      return Calendar;
  }
}
